// extracted by mini-css-extract-plugin
var _1 = "ApplicantFitCheckBlockRow-moduleapplicantValue__tvFpL";
var _2 = "ApplicantFitCheckBlockRow-modulechip__uhVfX";
var _3 = "ApplicantFitCheckBlockRow-moduleedit__VqGpt";
var _4 = "ApplicantFitCheckBlockRow-modulelabel__m1HqX";
var _5 = "ApplicantFitCheckBlockRow-modulemuted__sizKl";
var _6 = "ApplicantFitCheckBlockRow-modulevalue__DijxY";
export { _1 as "applicantValue", _2 as "chip", _3 as "edit", _4 as "label", _5 as "muted", _6 as "value" }
